
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/what-is-traffic-and-how-to-use-it-for-your-goals",
      function () {
        return require("private-next-pages/blog/what-is-traffic-and-how-to-use-it-for-your-goals.js");
      }
    ]);
  